<div fxLayout="column" >
  <p class="text-left"><b>{{title}}</b></p>
  <form fxLayout="column"  [formGroup]="form" (ngSubmit)="confirm()">
    <div fxLayout="row wrap" fxFlex="100" fxLayoutAlign="left start" >
        <div class="p-10" fxFlex.gt-sm="40" fxFlex="100">
            <mat-form-field class="mat-input" appearance="outline">
                <mat-label>{{dateFieldName}}</mat-label>
                <input required matInput [matDatepicker]="picker" formControlName="operationDate">
                <mat-hint>MM/DD/AAAA</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="p-10" fxFlex.gt-sm="60" fxFlex="100">
          <div class="name-container">
            <div><b>{{name}}</b></div>
          </div>
        </div>
    </div>

    <div  *ngIf="hasReason" fxLayout="row wrap" class="p-10" fxFlex.gt-sm="100" fxFlex="100">
      <mat-form-field>
        <mat-label>Ingrese el motivo de baja</mat-label>
        <mat-select
          formControlName="reasonId"
        >
        <!-- (selectionChange)="setReason($event, element)"
          [disabled]="isNotFalta(element)" -->
          <mat-option *ngFor="let reason of reasons" [value]="reason.id">
            {{ reason.reason }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mat-input" appearance="outline" >
          <mat-label>Comentarios</mat-label>
          <textarea matInput required  formControlName="comment" >
          </textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions  fxLayoutAlign="center"  class="p-b-15" >
      <button *ngIf="!confirmButtons" mat-raised-button class="text-center title" color="primary" (click)="confirm()">Ok</button>
      <ng-container *ngIf="confirmButtons">
          <button mat-raised-button  class="text-center title" color="primary" type="submit">Guardar</button>
          <button mat-raised-button  class="text-center title" (click)="close()" color="warn">Cancelar</button>
      </ng-container>
    </div>
  </form>
</div>
